/* tslint:disable */
/* eslint-disable */
export enum ValueFormatEnum {
  NA = 'NA',
  Percentage = 'Percentage',
  Dollar = 'Dollar'
}
